export AddressForm from './AddressForm';



// WEBPACK FOOTER //
// ./src/frontend/modules/address-book/address/components/index.js